<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="icon">
        <img
          :src="axios.platConfig.fileUri + 'mapicon/' + row.icon + '/4/1.gif'"
          style="width: 30px"
        />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1200"
      ref="formModel"
    >
      <tableForm
        slot="companyTtList"
        ref="companyTtList"
        height="200"
        :forms="companyTtListForms"
        :item1="companyTtListItem"
        v-model="item.companyTtList"
      >
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
var categorys = [];
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        type: "",
        companyTtList: [
          {
            companyName: "",
            companyNamePy: "",
            address: "",
            tel: "",
            fax: "",
            bankNo:'',
            websiteUrl: "",
          },
        ],
        remark: "",
        filesPath: "",
      },
      //http://127.0.0.1:8080/sellQuotation/exportWord?customerId=1648940548849164289&platformId=8162ea2e-29a5-4da7-b2f6-f48a8cc8e6c5&id=22&templetId=4&templetTtId=0
      forms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          span:8
        },
        
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          span: 8,
        },
        {
          title: "公司抬头信息列表",
          key: "companyTtList",
          slotForm: "companyTtList",
          required: true,
          noTable: true,
          span: 24,
        },
      ],
      companyTtListItem: {
        companyName: "",
        companyNamePy: "",
        address: "",
        bankNo:"",
        tel: "",
        fax: "",
        websiteUrl: "",
      },
      companyTtListForms: [
        {
          title: "公司名称",
          key: "companyName",
          required: "true",
          val: "",
          type: "Input",
        },
        {
          title: "名称拼音",
          key: "companyNamePy",
          required: true,
          type: "Input",
        },
        {
          title: "地址",
          key: "address",
          required: true,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: true,
          type: "Input",
        },
        {
          title: "银行账号",
          key: "bankNo",
          type: "Input",
        },
        {
          title: "传真",
          key: "fax",
          type: "Input",
        },
        {
          title: "公司网址",
          key: "websiteUrl",
          type: "Input",
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      total: 0,
      categorys: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/exportTemplet/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/exportTemplet/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-tms-server-base/exportTemplet/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-base/exportTemplet/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },

    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/daochumuban.vue